import { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSearchParams from '@hooks/useSearchParams';
import { StatusItemProps } from '@components/StatusMenu';

export const useOnlineDevices = (onViewChange?: (view: string) => void) => {
  const { t } = useTranslation(['simcards-online-product']);

  const { setSearchParams, searchParams } = useSearchParams({
    extraParams: ['statusFilter'],
  });

  const [activeStatusItem, setActiveStatusItem] = useState<string>(
    searchParams?.statusFilter || 'by-product',
  );

  const statusItems = useMemo(
    () => [
      {
        label: t('simcards-online-product:by-product'),
        value: 'by-product',
        color: 'var(--primary-color)',
      },
      {
        label: t('simcards-online-product:by-thecnology'),
        value: 'by-technology',
        color: 'var(--primary-color)',
      },
      {
        label: t('simcards-online-product:by-operator'),
        value: 'by-operator',
        color: 'var(--primary-color)',
      },
      {
        label: t('simcards-online-product:by-state'),
        value: 'by-state',
        color: 'var(--primary-color)',
      },
    ],
    [t],
  );

  const handleStatusCardSelect = useCallback(
    (item: StatusItemProps) => {
      setActiveStatusItem(item.value);
      setSearchParams({
        statusFilter: item.value,
      });

      if (onViewChange) {
        onViewChange(item.value);
      }
    },
    [setSearchParams, onViewChange],
  );

  const clearStatusSelection = useCallback(() => {
    setActiveStatusItem('all');
    setSearchParams({
      statusFilter: 'all',
    });

    if (onViewChange) {
      onViewChange('all');
    }
  }, [setSearchParams, onViewChange]);

  return {
    statusItems,
    activeStatusItem,
    handleStatusCardSelect,
    clearStatusSelection,
  };
};
